import { render } from "./CreateIncomeForm.vue?vue&type=template&id=00ecec16&scoped=true&ts=true"
import script from "./CreateIncomeForm.vue?vue&type=script&lang=ts"
export * from "./CreateIncomeForm.vue?vue&type=script&lang=ts"

import "./CreateIncomeForm.vue?vue&type=style&index=0&id=00ecec16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ecec16"]])

export default __exports__